var moduleMap = {
	"./app": () => {
		return Promise.all([__webpack_require__.e(4300), __webpack_require__.e(564), __webpack_require__.e(4914), __webpack_require__.e(1678), __webpack_require__.e(4118), __webpack_require__.e(4392), __webpack_require__.e(8069), __webpack_require__.e(3714)]).then(() => (() => ((__webpack_require__(3714)))));
	},
	"./settings": () => {
		return Promise.all([__webpack_require__.e(9596), __webpack_require__.e(4914), __webpack_require__.e(4392), __webpack_require__.e(4408), __webpack_require__.e(345)]).then(() => (() => ((__webpack_require__(345)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});